/** Keeps only the first user-perceived character (grapheme) of the input. */
export const firstGrapheme = (text: string): string => {
  const trimmed = text.trim();
  if (!trimmed) return '';
  const Segmenter = (Intl as { Segmenter?: typeof Intl.Segmenter }).Segmenter;
  if (!Segmenter) return Array.from(trimmed)[0] ?? '';
  const first = new Segmenter(undefined, { granularity: 'grapheme' })
    .segment(trimmed)
    [Symbol.iterator]()
    .next();
  return first.done ? '' : first.value.segment;
};
